import { FC, ChangeEvent } from 'react'
import dynamic from 'next/dynamic'

import Auth from 'store/auth'
const CommentInputBlock = dynamic(() => import('../comment-input-block/comment-input-block'))
const UnavailableCommentBottom = dynamic(() => import('./unavailable-comment-bottom'))
const NotFilledBanner = dynamic(
  () => import('components/banners/not-filled-banner/not-filled-banner')
)

import { resizeTexarea } from '../utils'
import { PLACEFLAG_COMMENT } from 'constants/analytic-data'
import { UnavailableReasons } from 'constants/webinar-data'

interface ICommentsBottom {
  handleSend: () => void
  setInputText: (text: string) => void
  inputText: string
  isSendBlocked: boolean
  isWithNMO: boolean
  isAllowComment?: boolean
}

const CommentsBottom: FC<ICommentsBottom> = ({
  handleSend,
  isSendBlocked,
  setInputText,
  inputText,
  isWithNMO,
  isAllowComment,
}: ICommentsBottom) => {
  const { isAuthorized, fakeAuth, isFilledUser, isSponsor } = Auth.useAuth()

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    resizeTexarea(e.target)
    setInputText(e.target.value)
  }

  return (
    <>
      {isAuthorized && !fakeAuth ? (
        !isFilledUser && !isSponsor ? (
          <NotFilledBanner placeFlag={PLACEFLAG_COMMENT}>
            Для размещения комментариев вам необходимо дополнить информацию о себе
          </NotFilledBanner>
        ) : (
          <>
            {isAllowComment ? (
              <CommentInputBlock
                inputText={inputText}
                handleChange={handleChange}
                handleSend={handleSend}
                isBthBlocked={isSendBlocked}
              />
            ) : (
              <UnavailableCommentBottom reason={UnavailableReasons.unpaid} />
            )}
          </>
        )
      ) : (
        <UnavailableCommentBottom reason={UnavailableReasons.unauth} />
      )}
    </>
  )
}

export default CommentsBottom
